// VehTypeGroupOrder.js
import React, { useEffect, useRef, useState } from 'react';
//import { styled } from '@mui/material/styles';
import { Button, IconButton } from '@mui/material';
import CachedIcon from '@mui/icons-material/Cached'; // refresh
import SettingsIcon from '@mui/icons-material/Settings';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { useSnackbar } from 'notistack';
import SearchBox from '../../common/SearchBox';
import {ContentConainer, ContentHeader, ControlBox, ToolBox} from '../../common/TopViewControl';
import { AppObject, AppStyle, AppWord } from '../../value/AppConst';
import { vehTypeGroupOrderListRepo, authTableTreeRepo } from '../../value/AppModel';
import {
    LIST_VEH_TYPE_GROUP_ORDER, devideTypesByGroupCode
} from './VehTypeGroupOrderGql';
import { VehTypeGroupOrderDictionary } from './VehTypeGroupOrderDict';
import { useAlertSetter, useAuthorizationCheck } from '../../api/app-hook';
import FlexyTable from '../../common/flexytable/FlexyTable';
import VehTypeGroupOrderEdit from './VehTypeGroupOrderEdit';

/**
 * 차종그룹에 차종을 배정, 제거하거나 순서를 조정하는 화면
 * 2개의 테이블. 좌측=IN, 우측=OUT
 * (VEH_TYPE_GROUP_ORDER) 정보 View Controller
 * Using React with MUI5
 * Project: NewTOP for cloud
 * 2024-08-21 10:28:31 using DbdbTap - Amend heavily
 */
export default function VehTypeGroupOrder({
    vehTypeGroup
}) {
    const vehTypeGroupOrderListData = useReactiveVar(vehTypeGroupOrderListRepo);
    const [typesInGroup, setTypesInGroup] = useState([]);
    const [typesOutGroup, setTypesOutGroup] = useState([]);
    const [openEditor, setOpenEditor] = useState(false);
    const [searchText, setSearchText] = useState('');
    const authTableTree = useReactiveVar(authTableTreeRepo);
    const checkAuth = useAuthorizationCheck();
    const addAlert = useAlertSetter();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const lastReloadRef = useRef(0);


    // ##### Call GraphQL to get List #####
    const [getVehTypeGroupOrderList, responseList] = useLazyQuery(LIST_VEH_TYPE_GROUP_ORDER, {
        ...AppObject.NoCachedFetch,
        onCompleted: (data, option) => {onCompleteGetList(data, option)},
		onError: (error) => addAlert({title: VehTypeGroupOrderDictionary.errorTitle.Get, message: [error.message]})
    });

    const devideTypes = (list) => {
        const twoGroups = devideTypesByGroupCode(vehTypeGroup.vehTypeGpCd, list);
        setTypesInGroup(twoGroups.inGroup);
        setTypesOutGroup(twoGroups.outGroup);
    };

    const getVehTypeGroupOrderListNow = () => {
        if(vehTypeGroup && vehTypeGroup.vehTypeGpCd) {
            const param = {variables:{vehTypeGpCd:vehTypeGroup.vehTypeGpCd}};
            getVehTypeGroupOrderList(param);
            lastReloadRef.current = new Date().getTime()/1000;
        }
    };

    useEffect(() => {
        devideTypes(vehTypeGroupOrderListData.records);
    }, [vehTypeGroupOrderListData]);

    useEffect(() => {
        if(vehTypeGroup && vehTypeGroup.vehTypeGpCd) {
            const diff = new Date().getTime()/1000 - vehTypeGroupOrderListData.when;
            if(diff > 300)
                getVehTypeGroupOrderListNow();
            else devideTypes(vehTypeGroupOrderListData.records);
        }
    }, [vehTypeGroup]);


    // >>>>>>>>> callbacks <<<<<<<<<<<<<
    const onCompleteGetList = (data, clientOption) => {
        if(data.vehTypeGroupOrderList) {
            vehTypeGroupOrderListRepo({when:new Date().getTime()/1000, records:data.vehTypeGroupOrderList});
        }
    };

    // >>>>>>>>> Event Handler <<<<<<<<<<<<<

    const onClickReload = () => {
        const diff = new Date().getTime()/1000 - lastReloadRef.current;
        if(diff < 60) {
            enqueueSnackbar(AppWord.ReloadNotInOneMinute, {variant:'info', autoHideDuration:2000});
        }
        else getVehTypeGroupOrderListNow();
    };

    const onChangeSearchText = (text) => {
        setSearchText(text);
    };

    const onClickEdit = () => {
        setOpenEditor(true);
    };

    const onRequestCloseEditor = () => {
        setOpenEditor(false);
    };

    /*
	CALL wps_set_auth_table('pr_veh_type_group_order_remove', '1,2', v_msg);
	CALL wps_set_auth_table('pr_veh_type_group_order_set', '1,2', v_msg);
    */
    const canSet = checkAuth(authTableTree.tree.pr_veh_type_group_order_set);

    return(
        <ContentConainer style={{flexGrow:1}}>
            <ContentHeader>
                <ControlBox>
                    <SearchBox
                        value={searchText}
                        onChangeText={onChangeSearchText}
                    />
                </ControlBox>
                <ToolBox>
                    {canSet &&
                    <Button
                        variant={AppStyle.mui.contained}
                        color={AppStyle.mui.primary}
                        onClick={onClickEdit}
                        disabled={!vehTypeGroup || !vehTypeGroup.vehTypeGpCd}
                        startIcon={<SettingsIcon />}
                        size={AppWord.SMALL}
                    >
                        차종선택
                    </Button>}
                    <IconButton
                        color={AppStyle.mui.inherit}
                        onClick={onClickReload}
                    >
                        <CachedIcon />
                    </IconButton>
                </ToolBox>
            </ContentHeader>
            <FlexyTable
                name={VehTypeGroupOrderDictionary.tableProps.tableId}
                tableProps={VehTypeGroupOrderDictionary.tableProps}
                records={typesInGroup}
                search={searchText}
                tools={[]}
            />
            <VehTypeGroupOrderEdit
                open={openEditor}
                vehTypeGroup={vehTypeGroup}
                onRequestClose={onRequestCloseEditor}
            />
        </ContentConainer>
    );
}
